<template>
  <ClSlider v-if="students.length" :items="students" :break-points="breakpoints" :autoplay="false" >
    <template #item="{ item }">
      <TopStudentCard :item="item" />

    </template>

  </ClSlider>

</template>

<script>
import ClSlider from "@/components/base/ClSlider.vue";
import TopStudentCard from "@/components/top-students/TopStudentCard.vue";

export default {
  components: {
    TopStudentCard,
    ClSlider,
  },
  props:['students'],
  data() {
    return {
      // Tops:'',
      breakpoints: {
        xs: {
          itemToShow: 1,
          itemToSlide: 1
        },
        sm: {
          itemToShow: 1,
          itemToSlide: 1
        },
        md: {
          itemToShow: 2,
          itemToSlide: 1
        },
        lg: {
          itemToShow: 2,
          itemToSlide: 1
        },
        xl: {
          itemToShow: 2,
          itemToSlide: 1
        }
      }
    }
  },
}
</script>

<style lang="scss" >
</style>
